import { useEffect, useState } from 'react'
import { useTheme } from 'styled-components'

import { Device } from 'constants/index'
import { numerify } from 'styles/constants'

export const useDevice = () => {
  const [device, setDevice] = useState(null)
  const { breakpoint } = useTheme()

  const getDevice = () => {
    if (typeof window === 'undefined') return setDevice('undefined')
    const width = window.innerWidth
    if (width >= numerify(breakpoint.desktop)) return setDevice(Device.DESKTOP)
    if (width >= numerify(breakpoint.tablet)) return setDevice(Device.TABLET)
    return setDevice(Device.MOBILE)
  }

  useEffect(() => {
    getDevice()
    window.addEventListener('resize', getDevice)
    return () => window.removeEventListener('resize', getDevice)
  }, [])

  return device
}

export default useDevice
